/**
 * «Доска обновилась» — when a board change is worth a toast.
 *
 * Only where there IS a board the visitor is not looking at: a narrow screen
 * showing the chat pane. `unseen` counts every A2UI node a frame upserts, and
 * since #127 the board-less `peterhof_agent` (`hasNoBoard`) sends A2UI frames
 * too — its suggested-reply chips live in `region:footer` and are drawn in the
 * chat strip (`Chips.tsx`). Toasting them would announce a board the visitor
 * has no way to open.
 */
export function announcesBoardUpdate(args: {
  noBoard: boolean;
  wide: boolean;
  pane: string;
  unseen: number;
}): boolean {
  const { noBoard, wide, pane, unseen } = args;
  return !noBoard && !wide && pane !== 'board' && unseen > 0;
}
